"use client";

import { useSyncExternalStore } from "react";

// WebGL scenes cost seconds of main-thread time on phones and GPU-less machines (shader
// compilation, environment maps, software rasterisation), which would land in the middle
// of page load. They wait for the reader's first sign of life instead: any pointer, key,
// touch, wheel or scroll. Until then each scene shows its lightweight poster.
const EVENTS = ["pointerdown", "pointermove", "keydown", "touchstart", "wheel", "scroll"] as const;
let engaged = false;
const listeners = new Set<() => void>();

function engage() {
  if (engaged) return;
  engaged = true;
  for (const name of EVENTS) window.removeEventListener(name, engage, true);
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void) {
  if (!engaged && listeners.size === 0) for (const name of EVENTS) window.addEventListener(name, engage, { capture: true, passive: true });
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

/** False until the reader first interacts with the page, then true for the rest of the visit. */
export function useEngaged() {
  return useSyncExternalStore(subscribe, () => engaged, () => false);
}
